var _path, _path2, _path3, _path4, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartNotificationloggedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33337 2.33333H4.36338C5.62338 2.33333 6.61504 3.41833 6.51004 4.66666L5.54171 16.2867C5.37837 18.1883 6.88337 19.8217 8.7967 19.8217H21.2217C22.9017 19.8217 24.3717 18.445 24.5 16.7767L25.13 8.02667C25.27 6.09 23.8 4.51499 21.8517 4.51499H6.79005",
    stroke: "#333333",
    strokeWidth: 1.82033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9585 25.6666C19.7639 25.6666 20.4168 25.0137 20.4168 24.2083C20.4168 23.4029 19.7639 22.75 18.9585 22.75C18.153 22.75 17.5001 23.4029 17.5001 24.2083C17.5001 25.0137 18.153 25.6666 18.9585 25.6666Z",
    stroke: "#333333",
    strokeWidth: 1.82033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62508 25.6666C10.4305 25.6666 11.0834 25.0137 11.0834 24.2083C11.0834 23.4029 10.4305 22.75 9.62508 22.75C8.81967 22.75 8.16675 23.4029 8.16675 24.2083C8.16675 25.0137 8.81967 25.6666 9.62508 25.6666Z",
    stroke: "#333333",
    strokeWidth: 1.82033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 9.33333H24.5001",
    stroke: "#333333",
    strokeWidth: 1.82033,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 5.2511,
    r: 5,
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartNotificationloggedin);
export default __webpack_public_path__ + "static/media/cart-notificationloggedin.480b207ffb46e636009922888b1da56a.svg";
export { ForwardRef as ReactComponent };